import { render, staticRenderFns } from "./Tablepersontofilms.vue?vue&type=template&id=dd6ad31e"
import script from "./Tablepersontofilms.vue?vue&type=script&lang=js"
export * from "./Tablepersontofilms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports